export const categories = [
  {
    slug: 'dianzi-youxi',
    name: '电子游戏',
    icon: 'ri-gamepad-line',
    description: '海量经典与全新电子游戏，震撼画面与丰厚奖励，尽在金沙娱乐电子游戏专区。',
    seoTitle: '电子游戏 – 金沙娱乐官方平台',
    seoDesc: '金沙娱乐电子游戏专区提供上千款经典老虎机、视频扑克、桌面游戏等，震撼视觉体验与超高赔率，立即体验电子游戏带来的无限乐趣。',
    seoKeywords: '电子游戏,老虎机,在线老虎机,金沙娱乐电子游戏,视频扑克',
  },
  {
    slug: 'zhenren-heguan',
    name: '真人荷官',
    icon: 'ri-live-line',
    description: '专业真人荷官实时发牌，高清直播互动体验，身临其境感受真实赌场氛围。',
    seoTitle: '真人荷官 – 金沙娱乐官方平台',
    seoDesc: '金沙娱乐真人荷官专区汇聚百家乐、轮盘、骰宝等经典真人游戏，专业荷官实时互动，高清画质让您足不出户尽享真实赌场体验。',
    seoKeywords: '真人荷官,真人百家乐,真人轮盘,真人骰宝,金沙娱乐真人',
  },
  {
    slug: 'tiyu-jingji',
    name: '体育竞技',
    icon: 'ri-football-line',
    description: '覆盖全球主流体育赛事，实时赔率更新，足球、篮球、网球等多种投注玩法。',
    seoTitle: '体育竞技 – 金沙娱乐官方平台',
    seoDesc: '金沙娱乐体育竞技平台提供足球、篮球、网球、电竞等全球赛事投注，实时赔率，快速结算，让您的体育观赛体验更加刺激精彩。',
    seoKeywords: '体育竞技,体育投注,足球投注,篮球投注,金沙娱乐体育',
  },
  {
    slug: 'caipiao-youxi',
    name: '彩票游戏',
    icon: 'ri-ticket-2-line',
    description: '多种彩票玩法任您选择，快速开奖，高额奖金，幸运就在指尖。',
    seoTitle: '彩票游戏 – 金沙娱乐官方平台',
    seoDesc: '金沙娱乐彩票游戏提供时时彩、快乐8、11选5等多种热门彩票玩法，高频开奖，奖金丰厚，让幸运触手可及。',
    seoKeywords: '彩票游戏,时时彩,快乐8,11选5,金沙娱乐彩票',
  },
  {
    slug: 'dianjing-jingji',
    name: '电竞竞技',
    icon: 'ri-computer-line',
    description: '英雄联盟、DOTA2、CS:GO等热门电竞项目，专业数据分析助力精准投注。',
    seoTitle: '电竞竞技 – 金沙娱乐官方平台',
    seoDesc: '金沙娱乐电竞竞技覆盖LOL、DOTA2、CS:GO、王者荣耀等热门电竞赛事，实时数据分析和专业赔率，为电竞爱好者提供最佳投注体验。',
    seoKeywords: '电竞竞技,电竞投注,英雄联盟,DOTA2,金沙娱乐电竞',
  },
  {
    slug: 'youhui-huodong',
    name: '优惠活动',
    icon: 'ri-gift-line',
    description: '新人礼包、首存优惠、每日返水、节日特惠，丰富活动等您参与。',
    seoTitle: '优惠活动 – 金沙娱乐官方平台',
    seoDesc: '金沙娱乐为您准备了新人专属礼包、首存高额赠送、每日返水优惠、VIP专属福利等丰富活动，让您的每一次游戏都物超所值。',
    seoKeywords: '优惠活动,新人礼包,首存优惠,返水优惠,VIP福利,金沙娱乐优惠',
  },
];